import { getFlag } from "../../../images/flags/getFlag";
import { CompetitorData } from "../DataProvider";
import { getGateColour } from "../../../utils/helper-funcs";

interface MarketSlipProps {
  competitorData: CompetitorData;
  compact?: boolean;
}

export function MarketSlip({ competitorData, compact = false }: MarketSlipProps) {
  const colour = getGateColour(competitorData.cardinal);
  const flag = getFlag(competitorData.name);
  const form = competitorData.form.split("");

  return (
    <div
      className={`flex items-center justify-between flex-1 w-full border-l-4 md:border-l-8 ${
        compact ? 'py-1' : ''
      }`}
      style={{ borderColor: colour }}
    >
      <div className="flex items-center flex-1 h-full gap-2 lg:gap-6">
        <div className={`flex items-center h-full gap-1 pl-3 lg:gap-3 lg:pl-4 lg:pr-2 ${
          compact ? 'pl-2' : ''
        }`}>
          <span className={`font-extrabold italic text-base md:text-[20px] leading-6 lg:leading-10 lg:text-[32px] text-center w-6 lg:w-12 ${
            compact ? 'text-sm md:text-base lg:text-xl' : ''
          }`}>
            {competitorData.cardinal}
          </span>
          <div className={`w-4 h-4 md:w-6 md:h-6 lg:w-12 lg:h-12 ${
            compact ? 'w-3 h-3 md:w-4 md:h-4 lg:w-8 lg:h-8' : ''
          }`}>
            <img src={flag} alt="" className="object-contain w-full h-full" />
          </div>
        </div>
        <span className={`text-sm italic font-normal leading-6 md:text-base lg:text-2xl ${
          compact ? 'text-xs md:text-sm lg:text-base truncate max-w-[120px] md:max-w-[150px] lg:max-w-[200px]' : ''
        }`}>
          {competitorData.name}
        </span>
      </div>
      <div className="flex items-center h-full gap-2 lg:gap-6">
        <ul className={`flex-1 flex gap-1 lg:gap-[2px] items-center ${
          compact ? 'gap-0.5' : ''
        }`}>
          {form.map((f, idx) => (
            <FormBox
              key={`${competitorData.name}-form-${idx}-${f}`}
              form={f}
              isLast={idx === form.length - 1}
              compact={compact}
            />
          ))}
        </ul>
        {/* <div className={`lg:w-[120px] w-12 bg-primary text-primary-foreground flex items-center justify-center h-full ${
          compact ? 'lg:w-[80px] w-10' : ''
        }`}>
          <span className={`text-sm italic font-extrabold md:text-base lg:text-2xl ${
            compact ? 'text-xs md:text-sm lg:text-xl' : ''
          }`}>
            {competitorData.oddsWin.toFixed(2)}
          </span>
        </div> */}
      </div>
    </div>
  );
}

interface FormBoxProps {
  form: string;
  isLast?: boolean;
  compact?: boolean;
}

function FormBox({ form, isLast, compact = false }: FormBoxProps) {
  return (
    <li
      className={`text-xs lg:text-base flex items-center justify-center w-2 lg:w-8 lg:h-8 ${
        form == "1"
          ? "text-primary lg:bg-primary lg:text-primary-foreground"
          : "text-foreground lg:bg-secondary lg:text-secondary-foreground"
      } ${isLast && 'border-b border-border'} ${
        compact ? 'text-[10px] lg:text-xs w-1.5 lg:w-6 lg:h-6' : ''
      }`}
    >
      {form}
    </li>
  );
}